// src/components/common/ContactModal.jsx
import React, { useState } from "react";
import api from "../../api/api";

export default function ContactModal({ isOpen, onClose, content }) {
    if (!isOpen) return null;

    const [form, setForm] = useState({
        name: "",
        email: "",
        assunto: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        setLoading(true);
        setSuccess("");
        setError("");

        try {
            await api.post("/contact", form);
            setSuccess("Mensagem enviada com sucesso! Obrigado pelo contato, em breve retornaremos.");
            setForm({ name: "", email: "",assunto:"" ,message: "" });
        } catch (err) {
            console.error(err);
            setError("Não foi possível enviar sua mensagem. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    const isShortcodeForm = content.includes("[form id=1]");

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 w-full max-w-lg relative shadow-2xl">
                
                {/* Botão fechar */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-900 transition"
                >
                    ✕
                </button>

                <h3 className="text-2xl font-extrabold mb-4 text-indigo-600 border-b pb-2">
                    Fale Conosco
                </h3>

                {/* Formulário REAL */}
                {isShortcodeForm ? (
                    <div className="space-y-3">

                        {success && <div className="bg-green-100 text-green-700 p-2 rounded">{success}</div>}
                        {error && <div className="bg-red-100 text-red-700 p-2 rounded">{error}</div>}

                        <input
                            name="name"
                            type="text"
                            placeholder="Seu Nome"
                            className="w-full p-2 border rounded"
                            value={form.name}
                            onChange={handleChange}
                        />

                        <input
                            name="email"
                            type="email"
                            placeholder="Seu Email"
                            className="w-full p-2 border rounded"
                            value={form.email}
                            onChange={handleChange}
                        />
                        
                        <input
                            name="assunto"
                            type="text"
                            placeholder="Digite o Assunto"
                            className="w-full p-2 border rounded"
                            value={form.assunto}
                            onChange={handleChange}
                        />

                        <textarea
                            name="message"
                            rows="4"
                            placeholder="Sua Mensagem"
                            className="w-full p-2 border rounded"
                            value={form.message}
                            onChange={handleChange}
                        ></textarea>

                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-full bg-indigo-600 text-white p-2 rounded hover:bg-indigo-700 transition disabled:opacity-50"
                        >
                            {loading ? "Enviando..." : "Enviar Mensagem"}
                        </button>
                    </div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
            </div>
        </div>
    );
}
